import { motion } from "framer-motion";
import { Dumbbell, ArrowUpRight } from "lucide-react";
import { DIGITAL_PRODUCTS } from "./catalog";

export default function TrainAnywhere() {
  const goOnline = () => { window.location.href = "/online-coaching"; };
  const bookEval = () => document.querySelector("#assessment")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="train-anywhere"
      data-testid="train-anywhere-section"
      className="py-16 md:py-36 bg-[#0a0a0a] border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl mb-14"
        >
          <p className="font-mono-accent text-xs tracking-[0.35em] uppercase text-white/40 mb-6">
            Digital Training
          </p>
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl">
            Train Anywhere
          </h2>
          <p className="mt-6 text-white/60 text-lg">
            Elite JJ Speed Factory training systems — now available anywhere
            through Origin Speed Academy online coaching.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {DIGITAL_PRODUCTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 3) * 0.08, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`product-card-${i}`}
              className="group flex flex-col bg-black border border-white/10 hover:border-white/30 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="relative aspect-[16/10] overflow-hidden border-b border-white/10 bg-[#111]">
                {p.img ? (
                  <img src={p.img} alt={p.title} loading="lazy" className="w-full h-full object-cover grayscale group-hover:scale-105 transition-transform duration-700" />
                ) : (
                  <div className="w-full h-full grain flex items-center justify-center">
                    <Dumbbell size={40} className="text-white/15" />
                  </div>
                )}
                <span className="absolute top-3 left-3 font-mono-accent text-[10px] tracking-[0.2em] uppercase text-white/50">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="absolute top-3 right-3 font-mono-accent text-[9px] tracking-[0.18em] uppercase text-white/70 border border-white/25 px-2 py-1 bg-black/40 backdrop-blur-sm">
                  {p.buyUrl ? "Available" : "In Academy"}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-6">
                <h3 className="font-display font-bold uppercase tracking-tight text-xl leading-none mb-2">
                  {p.title}
                </h3>
                <p className="text-white/50 text-sm flex-1">{p.desc}</p>
                <div className="mt-6 flex flex-col gap-2">
                  <button
                    data-testid={`product-online-${i}`}
                    onClick={goOnline}
                    className="w-full inline-flex items-center justify-center gap-2 bg-white text-black uppercase tracking-[0.12em] font-bold text-[11px] py-3 hover:bg-white/85 transition-colors duration-300"
                  >
                    Start Online Coaching <ArrowUpRight size={14} />
                  </button>
                  <button
                    data-testid={`product-book-${i}`}
                    onClick={bookEval}
                    className="w-full border border-white/20 text-white uppercase tracking-[0.12em] font-bold text-[11px] py-3 hover:bg-white/10 transition-colors duration-300"
                  >
                    Book Free Evaluation
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
